import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "../pages/public/Home";
import Login from "../components/auth/Login";
import Register from "../components/auth/Register";
import VerifyCertificate from "../pages/public/VerifyCertificate";
import About from "../pages/public/About";
import Contact from "../pages/public/Contact";
import Courses from "../pages/public/Courses";
import CourseDetails from "../pages/public/CourseDetails";
import Webinars from "../pages/public/Webinars";
import WebinarDetails from "../pages/public/WebinarDetails";
import Services from "../pages/public/Services";
import Kids from "../pages/public/Kids";
import Internship from "../pages/public/Internship";
import VocationalTraining from "../pages/public/VocationalTraining";
import Blog from "../pages/public/Blog";
import BlogDetails from "../pages/public/BlogDetails";
import Jobs from "../pages/public/Jobs";
import AppDevelopment from "../pages/kids/AppDevelopment";
import ArduinoElectronics from "../pages/kids/ArduinoElectronics";
import GameDevelopment from "../pages/kids/GameDevelopment";
import RoboticsForKids from "../pages/kids/RoboticsForKids";
import Pricing from "../pages/public/Pricing";
import Projects from "../pages/public/Projects";
import ProjectDetails from "../pages/public/ProjectDetails";
import DownloadProject from "../pages/public/DownloadProject";

const PublicRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} /> {/* Home at root */}
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/verify" element={<VerifyCertificate />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/courses" element={<Courses />} />
      <Route path="/courses/:id" element={<CourseDetails />} />
      <Route path="/webinars" element={<Webinars />} />
      <Route path="/webinars/:slug" element={<WebinarDetails />} />
      <Route path="/services" element={<Services />} />
      <Route path="/kids" element={<Kids />} />
      <Route path="/internship" element={<Internship />} />
      <Route path="/vocational-training" element={<VocationalTraining />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/blog/:slug" element={<BlogDetails />} />
      <Route path="/jobs" element={<Jobs />} />
      <Route path="/kids/app-development" element={<AppDevelopment />} />
      <Route
        path="/kids/arduino-electronics"
        element={<ArduinoElectronics />}
      />
      <Route path="/kids/game-development" element={<GameDevelopment />} />
      <Route path="/kids/robotics-for-kids" element={<RoboticsForKids />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/projects" element={<Projects />} />
      <Route path="/projects/:id" element={<ProjectDetails />} />
      <Route path="/download-project" element={<DownloadProject />} />
      {/* Add other public routes here */}
    </Routes>
  );
};

export default PublicRoutes;
